import GeneratePasswordButton from './GeneratePasswordButton';

export default GeneratePasswordButton;
